import { Component, AfterViewInit, Input, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, SortDirection } from '@angular/material/sort';
import { CaseService } from '../shared/services/case.service';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../shared/services/user.service';
import { BaseFilterComponent } from '../shared/components/table-filters/base-filter.component';
import { merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { SearchRequest } from '../shared/services/interfaces/search-request';
import { DateTime } from 'luxon';
import { faArchive } from '@fortawesome/pro-light-svg-icons';
import { ArchiveCaseComponent } from './../archive-case/archive-case.component';
import { ModalService } from '../shared/services/modal.service';

@Component({
  selector: 'app-uninstructed-case-list',
  templateUrl: './uninstructed-case-list.component.html',
  styleUrls: ['./uninstructed-case-list.component.scss']
})
export class UninstructedCaseListComponent implements AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);
  @ViewChild(MatSort) sort: MatSort = new MatSort();
  @ViewChildren('filter') filters!: QueryList<BaseFilterComponent>;

  resultsLength: number = 0;
  displayedColumns: string[] = ['dateCreated', 'financialAdviserName', 'companyGroup', 'caseType', 'partyOneFirstName', 'partyOneLastName',
    'partyOneAddressLine1', 'partyOnePostCode', 'caseReference', 'actions'];
  isLoadingResults = true;
  data: any[] = [];
  staff: any[] = [];
  faArchive = faArchive;

  tableName: string = "uninstructedCaseList";
  searchCriteria: SearchRequest = {page: 1, pageSize: 25, orderBy: "dateCreated", orderDirection: "desc", filterColumns: [], filterStrings: []};

  constructor(
    private caseService: CaseService, 
    private modalService: ModalService,
    public authService: AuthService) {

  }

  ngAfterViewInit() {
    this.loadCaseData();
  }

  loadCaseData() {

    let storedSearchCriteria = localStorage.getItem(this.tableName);
    let searchRequest = {page: 1, pageSize: 25, orderBy: this.sort.active, orderDirection: this.sort.direction, filterNames: [], filterColumns: [], filterStrings: []};

    if(storedSearchCriteria != null)
    {
      searchRequest = JSON.parse(storedSearchCriteria);

      this.filters.forEach((item : any) => {

        if(item.componentTypeName == "StringFilterComponent" || item.componentTypeName == "DateFilterComponent" || item.componentTypeName == "AutocompleteFilterComponent")
        {
          var columnIndex = searchRequest.filterColumns.findIndex(element => element == item.filterColumn);
          var filterName = searchRequest.filterNames[columnIndex];
          var storedValue = searchRequest.filterStrings[columnIndex];
          item.filterName = filterName;
          item.filterValue = storedValue;
        }

      });

      this.searchCriteria.filterColumns = this.filters.map(button => button.filterColumn);
      this.searchCriteria.filterStrings = searchRequest.filterStrings;
      this.sort.active = searchRequest.orderBy;
      this.sort.direction = searchRequest.orderDirection as SortDirection;
      this.sort.sortChange.emit();
    }

    const outputs = this.filters.map(button => button.filter);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(...outputs).subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, ...outputs)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          this.searchCriteria.page = this.paginator.pageIndex + 1;
          this.searchCriteria.pageSize = this.paginator.pageSize;
          this.searchCriteria.orderBy = this.sort.active;
          this.searchCriteria.orderDirection = this.sort.direction;

          this.searchCriteria.filterStrings = this.filters.map(button => button.filterValue);
          this.searchCriteria.filterColumns = this.filters.map(button => button.filterColumn);

          let saveSearch = {
            page: this.paginator.pageIndex + 1,
            pageSize: this.paginator.pageSize,
            orderBy: this.sort.active,
            orderDirection: this.sort.direction,
            filterNames: this.filters.map(button => button.filterName),
            filterColumns: this.filters.map(button => button.filterColumn),
            filterStrings: this.filters.map(button => button.filterValue)
          };

          localStorage.setItem(this.tableName, JSON.stringify(saveSearch));

          return this.caseService.uninstructedCases(this.searchCriteria);

        }),
        map(data => {

          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.resultsLength = data.recordCount;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  archiveCase(id: number) {

     const modalRef = this.modalService.openWithOptions(ArchiveCaseComponent, {size: 'md'});
        modalRef.componentInstance.caseId = id;
    
        modalRef.result.then(
            (result) => {
              if(result)
              {
                this.loadCaseData();
              }
        },
      () => {} // dismissed - do nothing
    );
  }

}
